import React from 'react';
import Modal from '../Modal';
import {
  DefaultButton,
  ItemContainer,
  LineItemsSecondary,
  Title,
  Value,
} from './styles';
import { DownloadRounded } from '@mui/icons-material';

export default function CertificateOfNeutralizationModal({ data, toggleShowCertificateModal }) {  
  return (
    <Modal
      title="Meu Certificado de Neutralização"
      size="large"
      hasClose
      onBackdropClick={toggleShowCertificateModal}
      secondaryHeader
    >
      <div>
        <img
          src={data.certificateUrl}
          style={{ maxWidth: '100%' }}
          alt="Certificado"
        />
        <LineItemsSecondary>
          <ItemContainer>
            <Title>Registro</Title>
            <Value>{data.registration}</Value>
          </ItemContainer>
          <ItemContainer>
            <Title>Descrição</Title>
            <Value>{data.description}</Value>
          </ItemContainer>
          <ItemContainer>
            <Title>Certificado</Title>
            <Value>
              <DefaultButton>
                <DownloadRounded />
                Baixar Certificado
              </DefaultButton>
            </Value>
          </ItemContainer>
        </LineItemsSecondary>
      </div>
    </Modal>
  );
}
